export default __webpack_public_path__ + "static/media/soundcloud.4539cfb8.jpeg";